<mat-form-field class="w-full">
    <input matInput [formControl]="fGroup.get('keyValue')" autocomplete="off">
    <mat-error *ngIf="fGroup.get('keyValue').hasError('required')">
        {{'Ce champ est obligatoire'|transloco}}
    </mat-error>
</mat-form-field>
